import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-group-text',
  templateUrl: './form-group-text.component.html',
  styleUrls: ['./form-group-text.component.css']
})
export class FormGroupTextComponent  {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 100;
  @Input() messageRequired: string = '';
  @Input() messagePattern: string = '';
  @Input() messageCustomFn: string = '';
  @Input() showIconSuccess: boolean = false;
  @Input() messageFooter: string = '';
  @Input() messageFooterAction: string = '';
  @Input() popoverContent: string = '';

  @Output() eventActionFooter = new EventEmitter<any>();

  constructor() { }

  onClickActionFooter(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.eventActionFooter.next(null);
  }

}
